export const baseUrl = 'https://api.salamatful.ir/api/v1';
export const blogsUrl = '/webblog';
export const singleBlogUrl = '/webblog/blog/';
export const categoriesUrl = '/webblog/category';
export const categoryBlogsUrl = '/webblog/category/';
export const postFormUrl = '/ticket/email';
export const socialListUrl = '/social';
export const aboutUsUrl = '/statics/about-us';
